import Link from "next/link";
import IconButton from "@mui/material/IconButton";
import AccountCircleOutlined from "@mui/icons-material/AccountCircleOutlined";
import { useContext } from "react";
import { AuthContext } from "contexts/AuthContext";

export default function HeaderLogin() {
  const { auth, logout } = useContext(AuthContext);

  return (
    <Link 
      href={auth.isAuthenticated ? '/profile' : '/login'}
      prefetch={false}
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <IconButton>
        <AccountCircleOutlined 
          sx={{
            color: "grey.600"
          }} 
        />
      </IconButton>
    </Link>
  );
}